import { render, staticRenderFns } from "./Challenge2Fa.vue?vue&type=template&id=7266854f&scoped=true&"
import script from "./Challenge2Fa.vue?vue&type=script&lang=js&"
export * from "./Challenge2Fa.vue?vue&type=script&lang=js&"
import style0 from "./Challenge2Fa.vue?vue&type=style&index=0&id=7266854f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7266854f",
  null
  
)

component.options.__file = "Challenge2Fa.vue"
export default component.exports